<template>
  <div>
    <div class="banner">
      <div class="img" :height="bannerHeight+'px'">
      <img
      ref="bannerHeight"
      @load="imgLoad"
      style="display: block;width: 100%;height: 100%;"
      :src="banner"
      alt=""
      />
      <div class="spw-box">
        <ul class="spw-list">
          <li v-for="(item,index) in hotListInfo" :key="index">
            <p class="number">{{ item.content}}</p>
            <p class="title">{{ item.title }}</p>
          </li>
        </ul>
      </div>
    </div>
    </div>
    <div class="content">
      <p class="listtitle">典型案例</p>
      <ul>
        <li v-for="(item, index) in list" :key="index">
          <div class="left">
            <img
              :src="item.img"
              alt=""
              @mouseover="change1(index)"
              @mouseleave="change2"
            />
            <p class="item" v-show="active == index">{{ item.name }}</p>
          </div>
          <div class="right">
            <p class="title">{{ item.name }}</p>
            <p class="des">
              {{ item.desc }}
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { baseUrl } from "../api/index";
import Swiper from "@/components/Swiper.vue";
export default {
  components: { Swiper },
  data() {
    return {
      h: 460,
      active: -1,
      isShow: false,
      list: [],
      hotListDesc:"",
      hotListInfo:[],
      banner: "",
      desc:"",
      bannerHeight: "",
    };
  },
  created() {
    this.getCategoryInfo({ mid: 5 });
  },
  mounted() {
    this.imgLoad();
    window.addEventListener(
      "resize",
      () => {
        this.imgLoad();
      },
      false
    );
  },
  methods: {
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
      });
    },
    change1(index) {
      this.active = index;
    },
    change2() {
      this.active = -1;
    },
    async getCategoryInfo(params) {
      let res = await this.$api.getCategoryInfo(params);
      this.list = res.data.data.category_info;
      this.list.forEach((ele) => {
        ele.img = baseUrl + ele.img;
      });
      this.hotListDesc=res.data.data.product_list[0].desc
      this.hotListInfo=JSON.parse(res.data.data.product_list[0].info) 
      this.banner = baseUrl + res.data.data.menu_info.banner;
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 1200px) {
  .banner {
    width: 100%;
    // height: 4.6rem;
    .img{
      position: relative;
    }
    .spw-box {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      bottom: -33px;
      box-shadow: 0 0 50px rgba(0, 0, 0, 0.15);
      width: 1200px;
      height: 100px;
      margin: 0 auto;
      background-color: #fff;
      border-radius: 5px;
      padding-top: 35px;
      padding-bottom: 15px;
      text-align: center;
      // &:hover{
      //   box-shadow: 0 0 70px rgba(0, 0, 0, 0.2);
      // }
      .spw-list {
        display: flex;
        li {
          flex: 1;
          .number {
            font-weight: 900 !important;
            font-size: 30px !important;
            color: #2576fb !important;
            line-height: 36px;
          }
          .title {
            font-size: 16px;
            line-height: 36px;
          }
        }
      }
      .spw-desc{
        padding: 10px 35px 10px 20px;
        text-align: left;
        line-height: 18px;
      }
    }
  }
  .content {
    width: 12rem;
    margin: 0 auto;
    margin-top: 0.5rem;
    color: #8c8b8b;
    .listtitle {
      position: relative;
      color: #333;
      font-weight: bold;
      font-size: 0.36rem;
      margin-top: 0.53rem;
      text-align: center;
      &::after {
        position: absolute;
        top: 0.56rem;
        left: 6rem;
        margin-left: -0.3rem;
        content: "";
        display: inline-block;
        height: 0.08rem;
        width: 0.6rem;
        border-radius: 0.05rem;
        background: linear-gradient(90deg, #3f66f5, #009fff);
      }
    }
    li {
      display: flex;
      padding: 0.4rem 0 0.4rem;
      // border-bottom: 1px solid #eee;
      border-bottom: 1px solid hsl(0, 6%, 90%);
      margin-top: 0.35rem;
      margin-bottom: 0.3rem;
      &:last-child {
        border-bottom: none;
      }

      .left {
        position: relative;
        width: 5rem;
        height: 3rem;
        img {
          width: 100%;
          height: 100%;
        }
        .item {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 0.6rem;
          line-height: 0.6rem;
          background-color: #e8e0e0a3;
          text-align: center;
          font-weight: 400;
          font-size: 0.18rem;
          color: black;
        }
      }

      .right {
        width: 7rem;
        margin-left: 0.35rem;
        margin-top: 0.1rem;
        .title {
          font-size: 0.24rem;
          margin-bottom: 0.2rem;
        }
        .des {
          font-size: .16rem;
          line-height: 25px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 9;
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .banner {
    width: 100%;
    // height: 1.5rem;
    margin-bottom: 0.15rem;
    .img{
      position: relative;
    }
    .spw-box {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      bottom: -0.06rem;
      box-shadow: 0 0 50px rgba(0, 0, 0, 0.15);
      width: 2.8rem;
      height: 0.28rem;
      margin: 0 auto;
      background-color: #fff;
      border-radius: 3px;
      padding-top: 0.05rem;
      padding-bottom: 0.03rem;
      text-align: center;
      // &:hover{
      //   box-shadow: 0 0 70px rgba(0, 0, 0, 0.2);
      // }
      .spw-list {
        display: flex;
        li {
          flex: 1;
          .number {
            font-weight: 900 !important;
            font-size: 0.1rem !important;
            color: #2576fb !important;
            line-height: 0.15rem;
          }
          .title {
            font-size: 0.08rem;
            line-height: 0.14rem;
          }
        }
      }
      // .spw-desc{
      //   padding: 5px 4px 2px 4px;
      //   text-align: left;
      //   line-height: 8px;
      //   font-size: 6px;
      // }
    }
  }
  .content {
    width: 3.2rem;
    margin: 0 auto;
    // margin-top: 0.5rem;
    color: #8c8b8b;
    .listtitle {
      position: relative;
      color: #333;
      font-weight: bold;
      font-size: 0.12rem;
      text-align: center;
      &::after {
        position: absolute;
        top: 0.2rem;
        left: 1.75rem;
        margin-left: -0.28rem;
        content: "";
        display: inline-block;
        height: 0.04rem;
        width: 0.3rem;
        border-radius: 0.025rem;
        background: linear-gradient(90deg, #3f66f5, #009fff);
      }
    }
    li {
      display: flex;
      padding: 0.05rem 0 0.1rem;
      border-bottom: 1px solid hsl(0, 6%, 90%);
      margin-top: 0.2rem;
      margin-bottom: 0.1rem;
      &:last-child {
        border-bottom: none;
      }

      .left {
        position: relative;
        width: 3rem;
        height: 0.8rem;
        img {
          width: 100%;
          height: 100%;
        }
        .item {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 0.6rem;
          line-height: 0.6rem;
          background-color: #e8e0e0a3;
          text-align: center;
          font-weight: 400;
          font-size: 0.1rem;
          color: black;
        }
      }

      .right {
        width: 4rem;
        margin-left: 0.2rem;
        margin-top: 0.05rem;
        .title {
          font-size: 0.12rem;
          margin-bottom: 0.05rem;
        }
        .des {
          font-size: 0.08rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          word-break: break-all;
          line-height: 0.11rem;
        }
      }
    }
  }
}
</style>